import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';

@Component({
  selector: 'advanced-search-footer',
  templateUrl: './advanced-search-footer.component.html',
  styleUrls: ['./advanced-search-footer.component.scss'],
})
export class AdvancedSearchFooterComponent implements OnInit {
  @Output('reset') reset = new EventEmitter<boolean>();
  @Output('apply') apply = new EventEmitter<boolean>();
  @Input() disabled = false;
  @Input() hasErrors = false;

  resetFilter() {
    this.reset.emit(true);
  }

  applyFilter() {
    this.apply.emit(true);
  }

  constructor() {}

  ngOnInit(): void {}
}
